export const emailDomains = {
  NEURAHEALTH: "neurahealth.co",
  HTD: "htdhealth.com",
};

export const EXCLUDED_FROM_TRACKING = [emailDomains.NEURAHEALTH, emailDomains.HTD];
